import APIConfiguration from '@savgroup-front-common/configuration/src/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/src/shared/supportedMethods';
import { GotAnErrorFromEndpoint } from '@savgroup-front-common/exceptions';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/src/client/errors/RequiredPayloadFieldIsNotProvided';
import { BaseBackResponse, FileId } from '@savgroup-front-common/types';

import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/technicalIntervention`;

export interface CreateTechnicalInterventionPayload {
  fileId: FileId;
  start: string | Date;
  end: string | Date;
  technicianIds?: string[];
  preciseStart?: string | Date;
  preciseEnd?: string | Date;
}

async function createTechnicalIntervention({
  fileId,
  start,
  end,
  technicianIds,
  preciseStart,
  preciseEnd,
}: CreateTechnicalInterventionPayload): Promise<BaseBackResponse> {
  const functionName = 'createTechnicalIntervention';

  if (!fileId || !start || !end) {
    throw new RequiredPayloadFieldIsNotProvided(
      'fileId && start && end',
      functionName,
    );
  }

  const response = await apiCall<BaseBackResponse>(ENDPOINT, {
    method: SUPPORTED_METHODS.POST,
    json: {
      fileId,
      start,
      end,
      technicianIds,
      preciseStart,
      preciseEnd,
    },
  });

  if (response.failure) {
    throw new GotAnErrorFromEndpoint(
      `Got an exception trying to ${functionName}`,
      response.errors,
    );
  }

  return response;
}

export default createTechnicalIntervention;
